export const PREFIX = 'i18n';
export const PREFIX_SEPARATOR = '_';
